export default __webpack_public_path__ + "static/kia_red-859a61453f940f455ddc5a31e15bf925.jpg";